<template>
  <div>
    <Head title="Recordings" />
    <h1 class="mb-8 text-3xl font-bold">Recordings</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Project:</label>
        <select v-model="form.project_id" class="form-select mt-1 w-full">
          <option :value="null" />
          <option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }}</option>
        </select>
        <label class="block text-gray-700">Stream:</label>
        <select v-model="form.stream_id" class="form-select mt-1 w-full">
          <option :value="null" />
          <option v-for="stream in streams" :key="stream.id" :value="stream.id">{{ stream.name }}</option>
        </select>
      </search-filter>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Name</th>
          <th class="pb-4 pt-6 px-6">Stream</th>
          <th class="pb-4 pt-6 px-6">Project</th>
          <th class="pb-4 pt-6 px-6">Organization</th>
          <th class="pb-4 pt-6 px-6"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="recording in recordings.data" :key="recording.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/recordings/${recording.id}/edit`">
              {{ recording.name }}
              <icon v-if="recording.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/recordings/${recording.id}/edit`" tabindex="-1">
              {{ recording.stream.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/recordings/${recording.id}/edit`" tabindex="-1">
              {{ recording.stream.project.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/recordings/${recording.id}/edit`" tabindex="-1">
              {{ recording.stream.organization?.name || null }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/recordings/${recording.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="recordings.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">No recordings found.</td>
        </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="recordings.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    streams: Object,
    recordings: Object,
    projects: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        project_id: this.filters.project_id,
        stream_id: this.filters.stream_id,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/recordings', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
